import { combineReducers } from 'redux';
import channelChannelView from './channelChannelView';
import chId from './chId';
//
export default combineReducers({
  channelChannelView,
  chId,
});
